import { useQuery } from '@tanstack/react-query';

import { aiIncidentsApi } from '../api/aiIncidents';
import { aiIncidentsQueryKeys } from './queryKeys';

type UseAiIncidentsParams = {
  eventId: number;
  page: number;
  pageSize: number;
  enabled?: boolean;
};

export const useAiIncidents = ({ eventId, page, pageSize, enabled = true }: UseAiIncidentsParams) =>
  useQuery({
    queryKey: aiIncidentsQueryKeys.list({ eventId, page, pageSize }),
    queryFn: () => aiIncidentsApi.getAiIncidents({ eventId, page, pageSize }),
    enabled,
  });
